export default __webpack_public_path__ + "static/2020-10856237dc5719e714b0ef7ccfd24201.jpg";